import styled from "styled-components";

// th
const Th = styled.th`
    border: 1px solid #aaa;
    background-clip: padding-box;
    scroll-snap-align: start;
    background-color: #f8f8f8;
    padding: 0.2rem;
    min-width: 2rem;
    text-align: left;
    margin: 0;
`

export default Th